export const setUpdatedAt = (updatedAt) => ({
  type: `app/updated_at`,
  updatedAt,
})

export const setLoading = (loading) => ({
  type: `app/loading`,
  loading,
})

export const setLocalLoading = (localLoading) => ({
  type: `app/local_loading`,
  localLoading,
})

export const setDatetime = (datetime) => ({
  type: `app/datetime`,
  datetime,
})